// extracted by mini-css-extract-plugin
export default {"container":"login_container__dJLcW","copyright":"login_copyright__fLV+A"};